import { useEffect, useRef } from "react";
import "../components/Sekcja.css";
import examplePhoto from "../assets/pictures/sandra-lustro.webp";

const Sekcja = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            element.classList.add("animate"); // Włącza animację
          } else {
            element.classList.remove("animate"); // Wyłącza → animuje ponownie
          }
        });
      },
      {
        threshold: 0.4,
      }
    );

    if (element) observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="section-wrapper scroll-animate" ref={sectionRef}>
      <div className="section-content">
        <h2>TWORZĘ PRZESTRZENIE Z CHARAKTEREM</h2>
        <p>
          Wierzę, że każde wnętrze powinno{" "}
          <strong className="highlight">opowiadać historię</strong> – być nie
          tylko piękne, ale też funkcjonalne i dopasowane do stylu życia jego
          mieszkańców.
        </p>
        <br />
        <p>
          Z pasją łączę{" "}
          <strong className="highlight">nowoczesne rozwiązania</strong> z
          ponadczasową estetyką.
        </p>
      </div>

      <div className="section-image">
        <img src={examplePhoto} alt="Projekt wnętrza" />
      </div>
    </div>
  );
};

export default Sekcja;